import {
  PrimarySmallButton,
  SecondarySmallButton
} from 'components/ReusableComponents/Button/SmallButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import useForm from 'hooks/useForm'
import { useToasts } from 'react-toast-notifications'
import pmsApi from 'services/api/pms'

import styles from '../MultiStepPMSLogin.module.scss'

const EnvironmentSetup = ({ setUpdateConfig, tenantId }) => {
  const { addToast } = useToasts()
  const [formData, handleFormChange] = useForm({
    tenantId: tenantId || '',
    clientId: '',
    clientSecret: '',
    gatewayUrl: '',
    step: 'Step4EnvironmentSetup'
  })

  const handleFormSubmission = e => {
    e.preventDefault()
    pmsApi
      .setOhipConfiguration(formData)
      .then(() =>
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
      )
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setUpdateConfig(prev => prev + 1)
      })
  }

  const handleTestAuth = () => {
    const { step, ...authData } = formData
    pmsApi
      .tryLoginOhipAuth(authData)
      .then(() =>
        addToast('Successful', {
          appearance: 'success',
          autoDismiss: true
        })
      )
      .catch(error => {
        addToast(`${error}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  return (
    <>
      <div className={styles.infoBar}>
        <span>An email is sent to developers with instructions</span>
      </div>
      <div className={styles.stepActions}>
        <p className={styles.cardDescription}>
          This step is under responsibility of engineering. Please follow up after 1
          business day.
        </p>
        <form onSubmit={handleFormSubmission}>
          <div className={styles.actionContainer}>
            <div className={styles.inputContainer}>
              <TextInput
                name="clientId"
                className={styles.textInput}
                type="string"
                label="Client id"
                value={formData.clientId}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className={styles.inputContainer}>
              <TextInput
                name="clientSecret"
                className={styles.textInput}
                type="string"
                label="Client secret"
                value={formData.clientSecret}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className={styles.inputContainer}>
              <TextInput
                name="gatewayUrl"
                className={styles.textInput}
                type="string"
                label="Gateway URL"
                value={formData.gatewayUrl}
                onChange={handleFormChange}
                required
              />
            </div>
            <div className={styles.inputContainer}>
              <SecondarySmallButton type="button" size="small" onClick={handleTestAuth}>
                Test auth
              </SecondarySmallButton>
              <PrimarySmallButton type="submit" size="small">
                Save & continue
              </PrimarySmallButton>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default EnvironmentSetup
